import styled from '@emotion/styled';
import { TableRow } from '@mui/material';

export const StyledTableContent = styled('div')(
  () => `
  background: #fff;
`,
);

export const StyledTableContentHeader = styled('div')(
  () => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 65px;
  padding: 0 20px 0 8px;

  .title {

  }

  .actions {

  }

  .MuiSvgIcon-root {
    color: #000;
  }
`,
);

export const StyledTableRow = styled(TableRow)(
  () => `
  cursor: pointer;
`,
);
